import React from 'react';

class Pentagon extends React.Component {


  render() {
    const { href, size } = this.props;

    const calcPath = size => {
      // let path = [ 0.2, 0, 0.8, 0, 1, 0.6, 0.5, 1, 0, 0.6 ];
      let path = [ 0.2, 1, 0.8, 1, 1, 0.4, 0.5, 0, 0, 0.4 ];
      path = path.map(v => v*size);
      return path.reduce((svgPath, v, i) => {
        if (i === 0) svgPath += 'M' + v;
        if (i % 2 === 1) svgPath += ',' + v;
        if (i > 0 && i % 2 === 0) svgPath += ' L' + v;
        if (path.length === i+1) svgPath += 'z';
        return svgPath;
      }, '');
      // return M20,0 L80,0 L100,60 L50,100 L0,60z
    };

    const svgTag = `
      <svg width=${size} height=${size} viewBox="0 0 ${size} ${size}">
        <defs>
          <clipPath id="shape">
            <path d="${calcPath(size)}" />
          </clipPath>
        </defs>
        <image  clip-path="url(#shape)"
                xlink:href=${href}
                x="0" y="0"
                height=${size} width=${size}
        />
      </svg>
    `;

    return (
      <div dangerouslySetInnerHTML={{ __html: svgTag }} />
    );
  }
}

Pentagon.propTypes = {
  href: React.PropTypes.string.isRequired,
  size: React.PropTypes.number.isRequired,
};

export default Pentagon;



/** WEBPACK FOOTER **
 ** ./components/Utils/Pentagon.js
 **/